var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 487 487",
      color: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664",
    transform: "translate(-329.289 -21.801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482,234.841l-116.5-67.262c-3.094-1.787-6.906-1.787-10,0c-3.094,1.786-5,5.088-5,8.66v57.28H10c-5.523,0-10,4.478-10,10 c0,5.522,4.477,10,10,10h340.5v57.242c0,3.571,1.906,6.874,5,8.66c1.547,0.893,3.272,1.34,5,1.34c1.727,0,3.453-0.446,5-1.34 L482,252.16c3.094-1.786,5-5.088,5-8.66C487,239.929,485.094,236.627,482,234.841z M370.5,293.441v-99.882L457,243.5L370.5,293.441 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.b998b6c2b21c4877fba95437b6fef169.svg";
export { ForwardRef as ReactComponent };